import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import BehandlingerPage from './pages/BehandlingerPage';
import BehandlingstyperPage from './pages/BehandlingstyperPage';
import PrislistePage from './pages/PrislistePage';
import OmOsPage from './pages/OmOsPage';
import KontaktPage from './pages/KontaktPage';
import FirmaordningPage from './pages/FirmaordningPage';
import AnmeldelserPage from './pages/AnmeldelserPage';
import BetingelserPage from './pages/BetingelserPage';
import TreatmentDetailPage from './pages/TreatmentDetailPage';
import JobPage from './pages/JobPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-[#1E293B]">
      <ScrollToTop />
      <Navbar />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/behandlinger" element={<BehandlingerPage />} />
          <Route path="/behandlinger/:slug" element={<TreatmentDetailPage />} />
          <Route path="/zoneterapi" element={<TreatmentDetailPage />} />
          <Route path="/voksbehandling" element={<TreatmentDetailPage />} />
          <Route path="/behandlingstyper" element={<BehandlingstyperPage />} />
          <Route path="/prisliste" element={<PrislistePage />} />
          <Route path="/om-os" element={<OmOsPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/kontakt/firmaordning" element={<FirmaordningPage />} />
          <Route path="/kontakt-firmaordning" element={<FirmaordningPage />} />
          <Route path="/job" element={<JobPage />} />
          <Route path="/jobansoegning" element={<JobPage />} />
          <Route path="/bliv-behandler" element={<JobPage />} />
          <Route path="/anmeldelser" element={<AnmeldelserPage />} />
          <Route path="/betingelser-mm" element={<BetingelserPage />} />

          {/* Error pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
